<template>
  <div class="_order-status-label">
    <span
      class="d-inline-block"
      :class="color"
      style="width: 10px; height: 10px; border-radius: 50%;">
    </span>
    {{ statusText }}
  </div>
</template>

<script>
export default {
  name: 'OrderStatusLabel',
  props: {
    status: {
      type: String,
      default: ''
    },
    deletedType: {
      type: String,
      default: ''
    }
  },
  computed: {
    color () {
      const colorData = {
        new: 'error',
        pending: '_pending-status-color',
        paid: 'info',
        completed: 'primary',
        rejected: 'black',
        deleted: 'grey'
      }

      return colorData[this.status]
    },
    statusText () {
      if (this.status === 'deleted' && this.deletedType === 'userCancel') {
        return 'ยกเลิกรายการสั่งซื้อ'
      }

      const textData = {
        new: 'ยังไม่ได้ชำระเงิน',
        pending: 'รอการตรวจสอบ',
        paid: 'กำลังดำเนินการ',
        completed: 'ดำเนินการเรียบร้อย',
        rejected: 'ถูกปฏิเสธ',
        deleted: 'ไม่สามารถใช้งานได้'
      }

      return textData[this.status]
    }
  }
}
</script>

<style scoped>
._pending-status-color {
  background-color: #F9DB05;
}
</style>
